import React, { useState, useEffect, useContext } from 'react'
import Button from '../../atoms/button/button'
import logoBusquedadMisteriosa from '../../../assets/images/logoBusquedadMisteriosa.png'
import userSessionStorage from './../../../utils/userSessionStorage'
import {
  gameId,
  dateEndGame,
  topNumber,
} from '../../../constants/activity-constants'
import { siteUrl } from '../../../shared/utils/siteUrl'
import gameServices from '../../../services/game-service'
import iconTop from '../../../assets/images/iconTop.png'
import { navigate } from 'gatsby'
import { Context } from '../../../context/app-context'

import './topContent.scss'

const TopContent = props => {
  const { mobile } = props
  const session = new userSessionStorage()
  const { dispatch } = useContext(Context)

  const [topWinners, setTopWinners] = useState([])
  const [userData, setUserData] = useState({})

  useEffect(() => {
    getTop()
  }, [])

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    gameServices.getTopPagination(gameId, 10, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
        console.log(res)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return
  }

  return (
    <div className="f-topContent-conainer">
      <div className="f-topContent-conainer__content">
        <div className="f-topContent-conainer__content__left">
          <Button
            text="Volver al Home"
            color="buttomVolver"
            icon="true"
            onClick={() => navigate('/')}
          />
          <img src={logoBusquedadMisteriosa} alt="logo bsuquedad misteriosa" />
        </div>
        <div className="f-topContent-conainer__content__right">
          {session.getUserInfo() ? (
            <div className="f-topContent-conainer__content__right__isLog">
              <div className="f-topContent-conainer__content__right__isLog__top">
                <img src={iconTop} alt="icono del top" />
                <h2 className="titleA">
                  Hola <span>{session.getUserInfo().name.split(' ')[0]}</span>
                </h2>
                <h2 className="titleB">
                  Tus Puntos{' '}
                  <span>
                    {userData.point ? formatNumber(userData.point) : 0}
                  </span>
                </h2>
                <h2 className="titleB">
                  Tu Puesto <span>{userData.position}</span>
                </h2>
              </div>
              <div className="f-topContent-conainer__content__right__isLog__bot">
                <span>
                  ¡
                  {process.env.LOCALE === 'es-AR' ||
                  process.env.LOCALE === 'es-PY'
                    ? 'BUSCÁ'
                    : 'BUSCA'}{' '}
                  TU NOMBRE ENTRE LOS MEJORES PUNTAJES!
                </span>
                <p>
                  Si no estás en <b>nuestro top {topNumber}</b>{' '}
                  {process.env.LOCALE === 'es-AR' ||
                  process.env.LOCALE === 'es-PY'
                    ? 'seguí'
                    : 'sigue'}{' '}
                  jugando!
                  <br />{' '}
                  <span className="spanA">
                    tienes hasta el {dateEndGame} para alcanzar los mejores
                    puntajes.
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <>
              <img src={iconTop} alt="icono del top" />
              <p>
                <span>
                  <a
                    onClick={() => {
                      dispatch({
                        type: 'set',
                        payload: {
                          modalActive: {
                            type: 'login',
                            props: {
                              close: () => {
                                navigate('/')
                                dispatch({
                                  type: 'set',
                                  payload: {
                                    modalActive: null,
                                  },
                                })
                              },
                              handleSuccess: () => {
                                window.location.reload()
                              },
                            },
                          },
                        },
                      })
                    }}
                  >
                    {process.env.LOCALE === 'es-AR' ||
                    process.env.LOCALE === 'es-PY'
                      ? 'Iniciá'
                      : 'Inicia'}{' '}
                    sesión{' '}
                  </a>
                </span>{' '}
                para conocer tu puntaje
                <br /> y tu posición dentro del top de jugadoras. <br /> <br />
                Si aún no{' '}
                {process.env.LOCALE === 'es-AR' ||
                process.env.LOCALE === 'es-PY'
                  ? 'formás'
                  : 'formas'}{' '}
                parte de NosotrasOnline{' '}
                <span>
                  <a
                    href={siteUrl + '/registro/fecha-de-nacimiento/'}
                    target="_blank"
                  >
                    {process.env.LOCALE === 'es-PY'
                      ? 'REGISTRATE ACÁ'
                      : 'regístrate aquí'}
                  </a>
                </span>
              </p>
            </>
          )}

          <div className="f-topContent-conainer__content__right__list">
            <ol>
              {!mobile && (
                <li>
                  <span className="titleList">NOMBRE</span>
                  <span className="titleList">CORREO</span>
                </li>
              )}
              {topWinners.map((item, index) => {
                return (
                  <li key={'top' + index}>
                    <span>
                      <b>{index + 1}</b> {item.name}
                    </span>
                    <span>{item.email}</span>
                    <span />
                  </li>
                )
              })}
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopContent
